module.exports = __webpack_public_path__ + "img/ic-ciudadazul.d2f4b5bb.png";